import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { WindowRef } from '@spartacus/core';

import { LANGUAGES } from '@app/core/constants/languages.constant';

@Injectable({ providedIn: 'root' })
export class DpFallbackLanguageService {
  readonly defaultLanguage = 'en';
  readonly #platformId = inject(PLATFORM_ID);
  readonly #winRef = inject(WindowRef);

  get fallbackLanguage(): string | undefined {
    if (isPlatformBrowser(this.#platformId)) {
      const navigatorLang = this.#winRef?.nativeWindow?.navigator?.language?.substring(0, 2);
      return LANGUAGES.find((language) => language === navigatorLang);
    }
  }
}
